class Slider {

    constructor() {
        this.initialise();
    }

    initialise() {
        $('[data-slider]').each(function(index, element) {

            const instance = $(this).eq(0),
                  effect = instance.data('effect');

            new Swiper(instance, {

                effect: effect === undefined ? 'slide' : effect,

                slideClass: 'slide',
                slideActiveClass: 'slide-active',
                slideVisibleClass: 'slide-visible',
                slideDuplicateClass: 'slide-duplicate',
                slideNextClass: 'slide-next',
                slidePrevClass: 'slide-prev',

                pagination: instance.find('.swiper-pagination')[0],
                nextButton: instance.find('.swiper-button-next')[0],
                prevButton: instance.find('.swiper-button-prev')[0],
                slidesPerView: 1,
                paginationClickable: true,
                spaceBetween: 0,
                loop: true,
                speed: 2000,
                autoplay: 8000,
                autoplayDisableOnInteraction: false,

                parallax: true

            })

        });
    }
}

export default Slider;


// WEBPACK FOOTER //
// ./resources/js/src/core/Slider.js